import { faqs, howItWorks, purchaseSeatsLanguages } from "./helpers";
import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import {
  DefaultRegistrationTerms,
  DefaultCheckoutTerms,
} from "../../default_terms_and_conditions";

import BannerImage from "public/images/predators/2024_25.jpg";
import SeatMap3dPreview from "public/images/predators/seat_map_preview.png";
import BackgroundImage from "public/images/predators/predators_background.jpeg";
import LogoImage from "public/images/predators/Nashville-Predators-Logo-PNG-768x450.png";

import type { TeamConfig } from "@/global/hooks/useTeamConfig";

const config: TeamConfig = {
  teamSchema: "predators_flex",
  browserTitle: "Nashville Predators",
  packages: true,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Nashville Predators",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10207-predators-sec",
    mapId: "blockmap2d",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.purchaseSeats,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: "SECTION-LEVEL",

  // purchase seat configs
  purchaseSeatConfigs: {
    minGameSelectionCount: 4,
    minSeatLimit: 2,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,

    hideViewTicketsInThankYouPage: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: true,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: 3,
    allowedPaymentFailCount: 3,
  },

  isSaveCardAllowed: true,
  oktaClientId: "",
  oktaIssuer: "",
  platform: vendorUUIDs.ticketmaster,
  refreshInventoryWhenEventClick: false,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "G-KW6CBLTM2R",
    attrkPixelId: "",
    beaconId: "",
    metaPixelId: "817574543511536",
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/predators/",

  // images
  images: {
    findGamesBannerImage: BannerImage.src,
    authBackgroundImage: BackgroundImage.src,
    checkoutStatusPageImage: BackgroundImage.src,
    logoImage: LogoImage.src + "?width=128&height=75", // actual size 768x450
    logoNameImage: "",
    faviconImage: LogoImage.src,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },
    bottomBar: {
      showGameSelectionProgress: false,
    },
  },

  colors: {
    primary: "#041E42",
  },

  howItWorks,
  faqs,

  languages: {
    topNavMenuItems: "", // can be react node as well
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: purchaseSeatsLanguages,
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage:
      "Tickets will be delivered to your Nashville Predators Account Manager by the end of August.",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster account above.",
        },
        logout: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
        },
        success: {
          description: "has been added to to your account!",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
